export default __webpack_public_path__ + "9e9bf575a06677e2be2c0d5f19d5b5e8.png";